import { type ComponentType } from "react";
import ReactCodeInputModule from "react-code-input";
import type { ReactCodeInputProps } from "react-code-input";

const ReactCodeInput = (
  ReactCodeInputModule as unknown as {
    default: ComponentType<ReactCodeInputProps>;
  }
).default;

export default ReactCodeInput;
